import FeaturedTitle from "./FeaturedTitle";
import React, { useEffect, useRef, useState } from "react";
import * as Text from "@/components/text";
import { motion } from "framer-motion";
import useWindowSize from "@/hooks/useWindowSize";
import breakpoints from "@/constants/breakpoinst";
import { Navigation, Pagination, Thumbs } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline";

const colorDir = {
  0: "hsla(208, 3%, 23%, 1)", // none
  13: "hsla(356, 100%, 70%, 1)", // gira
  14: "hsla(48, 100%, 64%, 1)", // ambulante presenta
  15: "hsla(40, 28%, 59%, 1)", // mas alla
};

export function TitlesSlider({ titles }) {
  const afterRef = useRef(null);
  const [color, setColor] = useState(0);
  const paginationRef = useRef(null);
  const beforeRef = useRef(null);
  const windowSize = useWindowSize();
  const [slideIndex, setIndex] = useState(0);
  return (
    <div className="relative space-y-11 overflow-hidden">
      <div className="relative space-y-11 md:mx-[116px] xl:mx-auto xl:max-w-[1207px]">
        <Swiper
          loop={true}
          onActiveIndexChange={({ realIndex }) => {
            setIndex(realIndex);
          }}
          slidesPerView={1}
          breakpoints={{
            [breakpoints.xl]: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 20,
            },
            [breakpoints.lg]: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 20,
            },
            [breakpoints.md]: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 20,
            },
            [breakpoints.sm]: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 20,
            },
          }}
          modules={[Thumbs, Navigation, Pagination]}
          pagination={{
            clickable: true,
            type: "bullets",
            el: paginationRef.current,
            currentClass: "bg-neutral-900",

            bulletClass: "block w-6 h-1 bg-gray-200 ",
            bulletActiveClass: "bg-neutral-900",
          }}
          navigation={{
            enabled: true,
            nextEl: afterRef.current,
            prevEl: beforeRef.current,
            hiddenClass: "hidden",
            disabledClass: "text-neutral-50 border-neutral-50",
          }}
        >
          {titles.map(({ id, attributes }, i) => {
            return (
              <SwiperSlide key={id} className="flex justify-center bg-white">
                <FeaturedTitle
                  category={
                    attributes?.categorias?.data[0]?.attributes?.name || ""
                  }
                  active={slideIndex === i}
                  setColor={setColor}
                  title={attributes.titulo}
                  original_title={attributes.subtitulo}
                  directors={attributes.autor}
                  image={attributes.cover_image}
                  content={attributes.contenido}
                  slug={attributes.slug}
                  publication_date={attributes.publishedAt}
                  movies={attributes.peliculas?.data}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div
          style={{ marginTop: 0 }}
          className="justify-center sm:flex lg:absolute lg:bottom-0 lg:left-0 lg:my-0 lg:justify-start"
        >
          <div className="flex items-center justify-center gap-5 align-middle lg:flex-row">
            {windowSize.width > breakpoints.lg ? (
              <button
                ref={beforeRef}
                className="absolute left-8 top-56 z-[1] bg-black/20 p-4  text-white/90 lg:relative lg:left-auto lg:top-0"
              >
                <ArrowLeftIcon className="h-4 w-4" />
              </button>
            ) : null}
            <div
              className="flex gap-5 lg:absolute lg:left-0 lg:z-[1] lg:ml-[150px] lg:w-[auto!important]"
              ref={paginationRef}
            ></div>
            {windowSize.width > breakpoints.lg ? (
              <button
                ref={afterRef}
                className="absolute right-8 top-56 z-[1] bg-black/20 p-4  text-white/90 lg:relative lg:right-auto lg:top-0"
              >
                <ArrowRightIcon className="h-4 w-4" />
              </button>
            ) : null}
          </div>
        </div>
      </div>
      <motion.div
        className="absolute top-0 w-full xl:w-[100vw]"
        animate={{ backgroundColor: colorDir[color] }}
      ></motion.div>
    </div>
  );
}

export default function FeatureTitlesContainer({ featured }) {
  return (
    <>
      <TitlesSlider titles={featured} />
    </>
  );
}
